import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1E3A5F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4 gap-2 bg-white rounded-lg p-3 inline-flex">
              <img
                src="/logo-cube.webp"
                alt="MoveMate Sydney Removals logo"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
                className="h-12 w-auto object-contain"
              />
              <div className="leading-none">
                <div className="text-xl font-extrabold text-[#1E3A5F] tracking-tight">MOVEMATE</div>
                <div className="h-0.5 bg-[#FF8C42] my-0.5"></div>
                <div className="text-[10px] font-bold text-[#FF8C42] tracking-widest">SYDNEY REMOVALS</div>
              </div>
            </div>
            <p className="text-blue-200 text-sm leading-relaxed">
              Your trusted moving partner in Sydney. Professional, reliable, and stress-free moving services.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-blue-200">
              <li>
                <button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-[#FF8C42] transition-colors">
                  Our Services
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-[#FF8C42] transition-colors">
                  Our Work
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('reviews')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-[#FF8C42] transition-colors">
                  Customer Reviews
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-[#FF8C42] transition-colors">
                  Get a Quote
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-blue-200">
              <li className="hover:text-[#FF8C42] transition-colors">Residential Moves</li>
              <li className="hover:text-[#FF8C42] transition-colors">Commercial Moves</li>
              <li className="hover:text-[#FF8C42] transition-colors">Packing Services</li>
              <li className="hover:text-[#FF8C42] transition-colors">Interstate Moves</li>
              <li className="hover:text-[#FF8C42] transition-colors">Furniture Assembly</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm text-blue-200">
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-[#FF8C42]" />
                <a
                  href="tel:+610487698671"
                  onClick={() => trackEvent('click_footer_phone', { number: '+610487698671' })}
                  className="hover:text-[#FF8C42] transition-colors">
                  +61 048 769 8671
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-[#FF8C42]" />
                <a
                  href="mailto:info@movematesydney.com"
                  onClick={() => trackEvent('click_email', { location: 'footer' })}
                  className="hover:text-[#FF8C42] transition-colors break-all">
                  info@movematesydney.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-[#FF8C42] mt-0.5 flex-shrink-0" />
                <span>Sydney Metro & NSW Regional</span>
              </li>
            </ul>
            {/* Social Links */}
            <div className="flex space-x-3 mt-4">
              <a href="#" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#FF8C42] transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#FF8C42] transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#FF8C42] transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-8 text-center text-sm text-blue-200">
          <p>&copy; {currentYear} MoveMate Sydney Removals. All rights reserved. | Fully Insured & Licensed</p>
        </div>
      </div>
    </footer>
  );
};